import { FC, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { fetchEmployeeBalance } from '../../../../store/slices/Tuition/tuitionApplySlice';
import Loader from '../../../../components/common/Loader';
import Notifications from '../../../../components/common/Notifications';


const EmployeeBalance:FC = () => {
  const dispatch = useAppDispatch();
  const employeeBalance = useAppSelector((state) => state.tuitionApply.employeeBalance);
  const balanceLoading = useAppSelector((state) => state.tuitionApply.loading);
  const balanceError = useAppSelector((state) => state.tuitionApply.employeeBalanceError);

  const currentYear = new Date().getFullYear();
  const priorYear = currentYear - 1;

  useEffect(() => {
  dispatch(fetchEmployeeBalance());
  }, [dispatch]);

  if (balanceLoading) {
    return <div><Loader /></div>;
  }

  if (balanceError) {
    return (
      <div className="flex items-center justify-center min-h-[300px]">
        <div className="w-full max-w-md">
          <Notifications messageInfo={balanceError} status={false} />
        </div>
      </div>
    );
  }

  if (!employeeBalance) {
    return <div><Loader /></div>;
  }

  return (
    <div>
      <div className="flex flex-col gap-4">
        <h3 className='h3'>Current Year: {currentYear}</h3>
      </div>
      <div>
          <p className="p3">Eligible Amount: {	employeeBalance.currentEligibleAmount}</p>
          <p className="p3">Actual Fees: {employeeBalance.currentTotalActualAmount !== null && employeeBalance.currentTotalActualAmount !== 0 ? `-${employeeBalance.currentTotalActualAmount}` : employeeBalance.currentTotalActualAmount}</p>
          <p className="p3">Remaining Available*:	{employeeBalance.currentRemainingBalance}</p>
      </div>

      <div className="flex flex-col gap-4 margin-top-2u">
        <h3 className='h3 gap-4'>Prior Year: {priorYear}</h3>
        </div>
        <div>
        <p className="p3">Eligible Amount: {	employeeBalance.previousEligibleAmount}</p>
        <p className="p3">Actual Fees:	{employeeBalance.previousTotalActualAmount !== null && employeeBalance.previousTotalActualAmount !== 0 ? `-${employeeBalance.previousTotalActualAmount}` : employeeBalance.previousTotalActualAmount}</p>
        <p className="p3">Remaining Available*:	{employeeBalance.previousRemainingBalance}</p>
      </div>

      <div className="flex flex-col gap-4 margin-top-2u">
        <p className="p3">Remaining available does not include estimated fees for classes where receipts have not been submitted and applied.</p>
        <p className="p3">If actual fees are greater than eligible amount, remaining available balance will be 0.</p>
      </div>
    </div>
  )
}

export default EmployeeBalance
